module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 33
// module chunks = 385